import { orderBy } from 'lodash'

export const sortBrands = (brands = []) =>
  orderBy(
    brands,
    [(brand) => (Number.isInteger(brand.sortOrder) && brand.sortOrder >= 0 ? brand.sortOrder : Infinity), 'name', 'id'],
    ['asc', 'asc', 'asc']
  )
